import { FC, useEffect } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { classById } from '../../graphQLOperations/Class';
import { ClassByIdQuery } from '../../graphQLOperations/__generated__/ClassByIdQuery.graphql';
import { ClassUser } from '../../models/Class';

interface Props {
  classId: string;
  onFetched: (users: ClassUser[]) => void;
}

/**
 * Headless: fetches a single class fresh (classById returns up-to-date users
 * right after rostering, unlike the cached list query) and hands its users back
 * so the card's student count / co-teacher label update without a page refresh.
 */
const ClassUsersRefetcher: FC<Props> = ({ classId, onFetched }) => {
  const data = useLazyLoadQuery<ClassByIdQuery>(classById, { classId }, { fetchPolicy: 'network-only' });

  useEffect(() => {
    if (data?.class?.users) onFetched(data.class.users as unknown as ClassUser[]);
  }, [data]);

  return null;
};

export default ClassUsersRefetcher;
